import { useContext } from 'react';
import { assert } from 'es-toolkit';
import { CurrentOrganizationIdContext } from '../contexts/current-organization-id';

export function useCurrentOrganizationId() {
  const context = useContext(CurrentOrganizationIdContext);

  assert(
    context !== null,
    'Unable to retrieve current organization ID, ensure you are within a CurrentOrganizationIdProvider and the current organization has a valid ID'
  );

  return context;
}
